import { LedgerView } from "./LedgerView";

export function GiftsPage() {
  return (
    <LedgerView
      title="Gifts"
      helperText="Every gift sent and received across the platform — both sides of each gift transaction, drawn from the same ledger as everything else."
      fixedReasons={["gift_sent", "gift_received"]}
    />
  );
}
